import { Alert, Box, Chip, Stack, styled } from '@mui/material';

const StyledSubscriptionStatusTile = styled(Stack)(({ theme }) => ({
  height: '100%',
  borderRadius: theme.shape.borderRadius,
  textAlign: 'center',
  backgroundColor: theme.palette.secondary.lighter,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  padding: theme.spacing(2, 0),
  boxShadow: theme.customShadows.card,
  '& .middle-content': {
    padding: theme.spacing(2),
    color: '#fff',
    background: `linear-gradient(135deg, ${theme?.palette?.secondary?.light} 0%, ${theme?.palette?.secondary?.main} 100%)`,
  },
  ' & .MuiButton-root': {
    width: 'fit-content'
  },
}));

const StyledComingSoonTile = styled(Stack)(({ theme }) => ({
  height: '100%',
  borderRadius: theme.shape.borderRadius,
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  boxShadow: theme.customShadows.card,
  padding: theme.spacing(3, 2),
  '& img.coming-soon': {
    maxWidth: 140,
    maxHeight: 110,
    top: 10,
    bottom: 0,
    position: 'absolute',
    left: -35,
    zIndex: 333,
  },
}));

const StyledTopAlert = styled(Alert)(({ theme }) => ({
  borderRadius: 0,
  border: 'none',
  paddingRight: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  backgroundColor: theme?.palette.secondary.main,
  color: theme?.palette?.text?.primary,
  '& .MuiAlert-icon': {
    display: 'none',
  },
  '& .MuiAlert-action': {
    paddingTop: theme.spacing(0),
    alignItems: "center"
  },
  [theme.breakpoints.up('sm')]: {
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
  },
  [theme.breakpoints.up('lg')]: {
    paddingRight: theme.spacing(5),
    paddingLeft: theme.spacing(5),
  },
  '& .MuiAlert-message': {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    overflowX: 'hidden',
  },
  '& .MuiTypography-root': {
    whiteSpace: 'nowrap',
    width: `calc(100% - ${230}px)`,
    [theme.breakpoints.down('xl')]: {
      animation: '26s linear 0s infinite move',
    },
    [theme.breakpoints.down('md')]: {
      animation: '18s linear 0s infinite move',
    },
  },
  '& .MuiButton-root': {
    whiteSpace: 'nowrap',
  },
  '@keyframes move': {
    '0%': {
      transform: `translateX(100%)`,
    },
    '100%': {
      transform: 'translateX(-100%)',
    }
  },
}));

const StyledFooterTile = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette?.branded?.paper,
  padding: theme.spacing(2.4),
  '& .MuiButton-root': {
    whiteSpace: 'nowrap',
  },
  '& .MuiTypography-root': {
    color: '#312932',
    whiteSpace: 'nowrap',
    display: 'block',
  },
}));

type StyledAccountBadgeProps = {
  small?: string;
}

const StyledAccountBadge = styled(Chip)<StyledAccountBadgeProps>(({ theme, ...props }) => ({
  height: 26,
  '& .MuiChip-label': {
    paddingLeft: props?.small ? 0 : 8,
  },
  '& .MuiSvgIcon-root': {
    width: 18,
    height: 18,
  },
}));

export {
  StyledSubscriptionStatusTile,
  StyledComingSoonTile,
  StyledTopAlert,
  StyledFooterTile,
  StyledAccountBadge,
};
